import { render, staticRenderFns } from "./DoctorListAllAndNew.vue?vue&type=template&id=49b80502&scoped=true"
import script from "./DoctorListAllAndNew.vue?vue&type=script&lang=js"
export * from "./DoctorListAllAndNew.vue?vue&type=script&lang=js"
import style0 from "./DoctorListAllAndNew.vue?vue&type=style&index=0&id=49b80502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b80502",
  null
  
)

export default component.exports